module.exports = __webpack_public_path__ + "static/media/veneto-village-18.10ab547d.jpg";